/// <amd-module name="VSS/Features/ReduxDirectory/Constants" />
export namespace DirectoryTelemetryConstants {
    export const OWNERS_COUNT = "Directory_OwnersCount";
    export const FAVORITE_COUNT = "Directory_FavoriteCount";
}

export namespace DirectoryConstants {
    export const ARTIFACT_SCOPE_TYPE = "Project";
    export const LOCAL_STORAGE_KEY_PREFIX = "Directory_Group_State";
}
